var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYandexDirectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3922_5186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.686035 16C0.686035 11.7565 2.37174 7.68687 5.37233 4.68629C8.37291 1.68571 12.4426 0 16.686 0C20.9295 0 24.9992 1.68571 27.9997 4.68629C31.0003 7.68687 32.686 11.7565 32.686 16C32.686 20.2435 31.0003 24.3131 27.9997 27.3137C24.9992 30.3143 20.9295 32 16.686 32C12.4426 32 8.37291 30.3143 5.37233 27.3137C2.37174 24.3131 0.686035 20.2435 0.686035 16Z",
    fill: "#1A4A7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0701 31.7838C10.8632 31.2571 7.8935 29.7639 5.55811 27.5038L19.9741 14.2718L11.7341 16.2718C11.1887 16.4059 10.622 16.43 10.0671 16.3429C9.51227 16.2557 8.98031 16.0589 8.50227 15.7641C8.02422 15.4692 7.60966 15.0821 7.28274 14.6254C6.95582 14.1687 6.72309 13.6514 6.59811 13.1038C6.34475 11.9896 6.53894 10.8204 7.1389 9.84793C7.73887 8.87542 8.69663 8.17732 9.8061 7.90384L26.9581 3.73584C29.047 5.48502 30.6547 7.73865 31.6287 10.2832C32.6027 12.8277 32.9109 15.5788 32.5239 18.2757C32.1369 20.9727 31.0676 23.5261 29.4174 25.6941C27.7671 27.862 25.5906 29.5726 23.0941 30.6638C23.0461 30.0958 23.1021 29.5038 23.3021 28.9278L26.0221 20.8158L14.0701 31.7838Z",
    fill: "url(#paint0_linear_3922_5186)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3922_5186",
    x1: 39.9341,
    y1: 2.02384,
    x2: -14.8419,
    y2: 52.2878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF11D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3922_5186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.686035)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexDirectIcon);
export default __webpack_public_path__ + "static/media/Yandex_Direct_icon.3a20690f9e6b6519d0e892a41cf54009.svg";
export { ForwardRef as ReactComponent };